import {ContentType} from '@app/src/common/constants/contentType';
import {
  POWERPOINT_EXTENSIONS_MAP,
  IMAGE_EXTENSIONS_MAP,
  VIDEO_EXTENSIONS_MAP
} from '@app/src/components/file-storage/constants/galleryConstants';

const getItemContentType = (contentType: string): ContentType | null => {
  if (isContentTypeOfExtensionsMap(contentType, VIDEO_EXTENSIONS_MAP)) {
    return ContentType.VIDEO;
  }
  if (isContentTypeOfExtensionsMap(contentType, IMAGE_EXTENSIONS_MAP)) {
    return ContentType.IMAGE;
  }
  if (isContentTypeOfExtensionsMap(contentType, POWERPOINT_EXTENSIONS_MAP)) {
    return ContentType.POWERPOINT;
  }

  return null;
};

export const isContentTypeOfExtensionsMap = (contentType: string, extensionsMap: Map<string, string[]>): boolean => {
  for (const extensionContentTypes of extensionsMap.values()) {
    if (extensionContentTypes.includes(contentType)) {
      return true;
    }
  }
  return false;
};

export default getItemContentType;
